// extracted by mini-css-extract-plugin
module.exports = {"filter":"Filter_filter__1e-A1"};